/** Spinner — bordered ring with accent top, CSS spin animation (web layer). */
import React from 'react';
import { colors } from '../theme';

type Props = { size?: number; thickness?: number };

export default function Spinner({ size = 24, thickness = 3 }: Props) {
  // Plain div so the .t-anim-spin keyframe class applies cleanly on web.
  return React.createElement('div', {
    className: 't-anim-spin',
    style: {
      display: 'inline-block',
      width: size,
      height: size,
      borderWidth: thickness,
      borderStyle: 'solid',
      borderColor: colors.line,
      borderTopColor: colors.accent,
      borderRadius: 999,
      boxSizing: 'border-box',
    },
  });
}
